// Shared draggable-splitter handler for editor/preview panes.
//
// makeSplitterDrag returns an onPointerDown handler: while the pointer is held,
// it computes the pointer's fraction along `axis` of the host element's box and
// calls setRatio(fraction) on each move (the caller's setter is expected to
// clamp). Toggles a body cursor + userSelect for the drag, and cleans up on
// pointerup. `getHost` is a thunk so it works with a ref assigned after render.
//
// Used by the Forms and Imports DSL workbenches (axis 'x'); factored out so the
// two panels don't hand-roll identical drag closures.
export function makeSplitterDrag(getHost, setRatio, axis = 'x') {
  return (e) => {
    e.preventDefault();
    const host = getHost();
    if (!host) return;
    const move = (ev) => {
      const rect = host.getBoundingClientRect();
      if (axis === 'y') {
        if (rect.height > 0) setRatio((ev.clientY - rect.top) / rect.height);
      } else if (rect.width > 0) {
        setRatio((ev.clientX - rect.left) / rect.width);
      }
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    document.body.style.cursor = axis === 'y' ? 'row-resize' : 'col-resize';
    document.body.style.userSelect = 'none';
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
}
